import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Launch } from '@material-ui/icons';

import { useLocalization } from '../contexts/LocalizationContext';

const iconStyle = { height: '1rem', width: '1rem', marginLeft: '0.25rem' };

const links = [
  {
    label: 'footer.give.feedback',
    href: window._env.urls.feedback
  },
  {
    label: 'footer.privacy.and.cookies',
    href: window._env.urls.privacyAndCookies
  },
  {
    label: 'footer.accessibility.statement',
    href: window._env.urls.accessibility
  }
];

function FooterLink(props) {
  const { localize } = useLocalization();

  return (
    <Col sm={12} md={6} lg={3} className='text-nowrap'>
      <a className='link-style-override' target='_blank' href={props.href}>
        {localize(props.label)}
      </a>
      <Launch style={iconStyle} />
    </Col>
  );
}

const Footer = React.forwardRef((props, ref) => {
  return (
    <div ref={ref}>
      <Container fluid className='footer'>
        <Row className='footer-row text-center'>
          {links.map((link) => {
            if (link.href) return <FooterLink key={link.label} {...link} />;
          })}
        </Row>
      </Container>
    </div>
  );
});

export default Footer;
